import enviro from 'enviro';
import { getQueryParams } from 'pricing-pages-ui-components/utils/queryParamUtils';
import { Metrics } from '../../../utils/metrics';
import { trackCommunicationMethodsInteraction } from '../tracking/trackingEventUtils';
export class Chat {
  static getSettings() {
    if (!window.hsConversationsSettings) {
      window.hsConversationsSettings = {
        loadImmediately: false
      };
    }
    return window.hsConversationsSettings;
  }
  static getWidget() {
    var _HubSpotConversations;
    return (_HubSpotConversations = window.HubSpotConversations) === null || _HubSpotConversations === void 0 ? void 0 : _HubSpotConversations.widget;
  }
  static getApi() {
    return window.HubSpotConversations;
  }
  static onReady(callback) {
    const api = Chat.getApi();
    if (api) {
      callback();
    } else {
      const existing = window.hsConversationsOnReady || [];
      window.hsConversationsOnReady = [...existing, callback];
    }
    return Chat;
  }
  static getStatus() {
    var _Chat$getWidget;
    const status = (_Chat$getWidget = Chat.getWidget()) === null || _Chat$getWidget === void 0 ? void 0 : _Chat$getWidget.status();
    return {
      loaded: !!(status !== null && status !== void 0 && status.loaded),
      pending: !!(status !== null && status !== void 0 && status.pending)
    };
  }
  static updateSettings(settings) {
    Object.assign(Chat.getSettings(), settings);
    return Chat;
  }
  static setInlineEmbed(selector) {
    Chat.getSettings().inlineEmbedSelector = selector;
    return Chat;
  }
  static removeInlineEmbed() {
    delete Chat.getSettings().inlineEmbedSelector;
    return Chat;
  }
  static load() {
    return Chat.onReady(() => {
      Chat.getWidget().load();
    });
  }
  static refresh() {
    return Chat.onReady(() => {
      Chat.getWidget().refresh();
    });
  }
  static remove() {
    return Chat.onReady(() => {
      Chat.getWidget().remove();
    });
  }

  /**
   * @param event - {@link https://github.com/HubSpotEngineering/conversations-visitor/blob/master/conversations-embed/static/js/event-emitter/constants/eventTypeConstants.ts}
   * @param callback - Callback function that will be called when the event is emitted.
   * @returns Chat
   */
  static on(event, callback) {
    return Chat.onReady(() => {
      var _Chat$getApi;
      (_Chat$getApi = Chat.getApi()) === null || _Chat$getApi === void 0 || _Chat$getApi.on(event, callback);
    });
  }
  static off(event, callback) {
    var _Chat$getApi2;
    (_Chat$getApi2 = Chat.getApi()) === null || _Chat$getApi2 === void 0 || _Chat$getApi2.off(event, callback);
    return Chat;
  }
  static loadConversationsScript() {
    if (Chat.hasLoadedConversationsScript) {
      return;
    }
    Chat.hasLoadedConversationsScript = true;
    this.getSettings().loadImmediately = false;
    const isQa = enviro.isQa();
    const qaSuffix = isQa ? 'qa' : '';
    const queryParams = getQueryParams();
    let chatPortalId;
    if (isQa) {
      if (queryParams.useDefaultChatPortal !== undefined) {
        chatPortalId = '99535353';
      } else {
        chatPortalId = '100048175';
      }
    } else {
      chatPortalId = '53';
    }
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'hubspot-messages-loader';
    script.async = true;
    script.defer = true;
    script.src = `//js.usemessages${qaSuffix}.com/conversations-embed.js`;
    script.setAttribute('data-hsjs-env', enviro.getShort());
    script.setAttribute('data-hsjs-portal', chatPortalId);
    document.body.appendChild(script);
  }
  static setupTracking(trackingSource) {
    return Chat.onReady(() => {
      if (Chat.hasSetupTracking) {
        return;
      }
      Chat.hasSetupTracking = true;
      trackCommunicationMethodsInteraction({
        action: 'chat-conversation-loaded',
        trackingSource
      });
      Metrics.counter('live-chat-loaded', {
        location: trackingSource
      }).increment();
      const api = Chat.getApi();
      if (api) {
        api.on('conversationStarted', payload => {
          trackCommunicationMethodsInteraction({
            action: 'chat-conversation-started',
            trackingSource,
            conversationId: payload.conversation.conversationId
          });
          Metrics.counter('live-chat-interaction', {
            location: trackingSource
          }).increment();
        });
      }
    });
  }
}
Chat.hasSetupTracking = false;
Chat.hasLoadedConversationsScript = false;